import { createSlice } from "@reduxjs/toolkit";
import { clearSelectedLocationDispatch } from "../dispatch/location/clear-selected-location";
import { setLocationPageDispatch } from "../dispatch/location/set-location-page";
import { setLocationPageByDtoDispatch } from "../dispatch/location/set-location-page-by-dto";
import { setSelectedLocationDispatch } from "../dispatch/location/set-selected-location";
import { RootState } from "../store";
import { LocationState } from "../type/location-state";

const initialState: LocationState = {
  selectedLocation: undefined,
  locationPage: {
    contents: [],
    first: true,
    last: true,
    page: 0,
    totalPages: 1,
    totalElements: 0,
  },
  status: "idle",
};

export const locationSlice = createSlice({
  name: "locationSlice",
  initialState,
  reducers: {
    setLocationPageByDtoAction: setLocationPageByDtoDispatch,
    clearSelectedLocationAction: clearSelectedLocationDispatch,
    setSelectedLocationAction: setSelectedLocationDispatch,
    setLocationPageAction: setLocationPageDispatch,
  },
});

export const {
  setLocationPageByDtoAction,
  clearSelectedLocationAction,
  setSelectedLocationAction,
  setLocationPageAction,
} = locationSlice.actions;

export const locationState = (state: RootState) => state.location;

export default locationSlice.reducer;
